import docSignImg from "../../assets/img/docotr-signature.png";
import docSignImgWebp from "../../assets/img/docotr-signature.webp";

const ImportantMessage = () => (
    <section id="important-message">
        <div className="container-fluid py-5 ov-bg-solid-teal-light">
            <div className="row align-items-center justify-content-center text-center mb-2">
                <div className="col-xl-6 col-lg-8 col-11">
                    <h2 className="ov-text-blue fw-bold mb-4">Type 2 diabetes affects your blood sugar, and it also threatens your vision.</h2>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center">
                <div className="col-md-8 col-11">
                    <p>You've made an amazing choice starting your journey with GlucoGen<sup>17</sup> Naturals. <b>I'm proud of you</b> for taking control of your health and fighting back against type 2 diabetes. But here's the thing: type 2 diabetes doesn't just stop at your blood sugar, it takes aim at your vision, too.</p>
                    <p>You might not realize it, but right now your eyesight could be at risk. High blood sugar and chronic inflammation <b>quietly damage your vision, threatening your independence</b> and your ability to see clearly. I’ve seen too many patients struggle, and I couldn't stand by without doing something.</p>
                    <p className="fw-bold">That's exactly why I created OptiVista<sup>23</sup> Pro Naturals.</p>
                    <p>This is your personal shield for crystal-clear vision. Packed with powerhouse nutrients like Lutein, Zeaxanthin, Bilberry Extract, and Alpha-Lipoic Acid, OptiVista<sup>23</sup> protects your eyes, reduces inflammation, and supports healthier, sharper vision.</p>
                    <p>Think of <b>GlucoGen<sup>17</sup></b> and <b>OptiVista<sup>23</sup></b> as your <b>dream team</b>, working together so you can finally reclaim your health and independence.</p>
                    <p>Your journey isn't complete without clear vision. Protect your future and see the world clearly again with OptiVista<sup>23</sup> Pro Naturals.</p>
                    <p>I'm right here with you every step of the way.</p>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center mt-5">
                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-4 col-5">
                    <picture>
                        <source srcSet={docSignImgWebp} type="image/webp" />
                        <img className="img-fluid gg-img-signature" src={docSignImg} loading="lazy" />
                    </picture>
                </div>
            </div>
        </div>
    </section>
);

export default ImportantMessage;